/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0a354a15&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "../../assets/pbl/css/index.css?vue&type=style&index=0&id=0a354a15&scoped=true&lang=css&external"
import "./index.vue?vue&type=style&index=1&id=0a354a15&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=2&id=0a354a15&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a354a15"]])

export default __exports__